/**
 * No-op stub. The legacy VFS (IndexedDB-backed browser file system) was
 * retired in favour of Supabase Storage for corpus uploads. This stub keeps
 * the existing import surface alive so optional/legacy callers (blueprint
 * executor, graph data sources, OS-emulation hooks) compile and silently
 * degrade instead of crashing.
 *
 * IndexedDB usage at module load was also breaking SSR (`indexedDB is not
 * defined`) and forcing the server to fall back to the SPA shell on every
 * render — getting rid of the IndexedDB driver lets the SSR path render
 * cleanly again.
 */

// Keep a minimal class so `new VFS()` and `globalVFS.*` calls don't throw.
export class VFS {
  on(_event: string, _listener: (event: unknown) => void): void {}
  off(_event: string, _listener: (event: unknown) => void): void {}

  async save(_path: string, _content: string, _modified?: Date): Promise<void> {}
  async load(_path: string): Promise<string | null> { return null; }
  async delete(_path: string): Promise<void> {}
  async list(_path: string): Promise<string[]> { return []; }
  async exists(_path: string): Promise<boolean> { return false; }
  async createDirectory(_path: string, _modified?: Date): Promise<void> {}
  async getAllFiles(): Promise<unknown[]> { return []; }
  async clearAll(): Promise<void> {}
}

export const globalVFS = new VFS();
